import React from 'react';
import 'antd/dist/antd.css';
import './bodyRow.css';
import {
    Badge,
    Button,
    Icon,
    InputNumber,
    Modal,
    DatePicker,
    Table,
    message,
    Tooltip,
    Popover,
    Timeline,
    Select,
    Form,
    Input, Popconfirm,
} from 'antd';
import { DndProvider, DragSource, DropTarget } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import { connect } from "react-redux";
import {
    doTop,
    postAct,
    postPublic,
    setImportance,
    storySort,
    undo,
    restoredo,
    deletestorydo,
    updateNewsStatus,
    websiteDomainURLdo,
    judgeBindVsbAccountdo,
    loginVsbdo,
    getStoryType, sendEmail, getByConfigKey, getresources, delMoveFileToRecycle,getMediaRoleByColum
} from "../actions";
import moment from 'moment';
import {applicationName, uuid} from "../utils";
import { getStoryById } from "../view/desktop/components/activityTrends/FollowUpCorrespondenceComponents";
import SelectManuscriptPool from '../view/components/manuscriptPool/SelectManuscriptPool'
import RelationSelectTopicDetail from '../view/components/manuscriptPool/RelationSelectTopicDetail'
import AddTopic from '../components/resource-list/addTopic'
import TextArea from "antd/es/input/TextArea";
import { Scrollbars } from "react-custom-scrollbars";
import *as actions from "../actions/manuscriptPool"

const { Option } = Select;

const { Search } = Input;
const { RangePicker } = DatePicker;
let dragingIndex = -1;
const { confirm } = Modal

class BodyRow extends React.Component {
    render() {
        const { isOver, connectDragSource, connectDropTarget, moveRow, ...restProps } = this.props;
        const style = { ...restProps.style, cursor: 'pointer' };

        let { className } = restProps;
        if (isOver) {
            if (restProps.index > dragingIndex) {
                className += ' drop-over-downward';
            }
            if (restProps.index < dragingIndex) {
                className += ' drop-over-upward';
            }
        }

        return connectDragSource(
            connectDropTarget(<tr {...restProps} className={className} style={style} />),
        );
    }
}

const rowSource = {
    beginDrag(props) {
        dragingIndex = props.index;
        return {
            index: props.index,
        };
    },
};

const rowTarget = {
    drop(props, monitor) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;

        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }

        // Time to actually perform the action
        props.moveRow(dragIndex, hoverIndex);

        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    }
};

//<DragSortingTable type={"1"} currentMediaCode={"xww"} />

class DragSortingTable extends React.Component {



    params = {
        start: 1,
        size: 10
    };

    constructor(props) {
        super(props);
        if (this.props.columns) {
            this.setState({
                columns: this.props.columns,
            });
        }
        this.componentWillReceiveProps(props);
        this.range = this.range.bind(this);

        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = '/cm-sites/pms/website/common.js';
        document.head.appendChild(script);
        //this.disabledDateTime = this.disabledDateTime.bind(this);
        this.addTopicRef = React.createRef();
        this.actions = actions;
    }

    componentWillMount() {

        this.setState({
            openEmail: false,
            receivers: [],
            selectReceiver: [],
            emailVisible: false,
            currentStory: {},
            deletesVisible: false,
            stateRecord: {},
            deleteSources: [],
            btnLoadingStatus: false,
        });
        let that = this;
        getByConfigKey({ key: "open.send.email" }, function (data) {
            if (data && data == 1) {
                that.setState({
                    openEmail: true,
                })
            }
        });

        getByConfigKey({ key: "email.receivers" }, function (res) {
            that.setState({
                receivers: res,
            })
        });
    }

    /**
     * 设置置顶等信息
     * @param storyId
     * @param type 操作类型 （头条/取消头条：1 推荐/取消推荐：2 取消置顶：3）
     * @param flag 标识（设置：1 取消：0）
	 *
     */
    setUpOtherInfo(index, storyId, type, flag, e) {
        let that = this;
        flag = flag === 1 ? 0 : 1;
        updateNewsStatus({
            ...this.getPublicInfo(),
            storyId,
            optionType: type,
            flag: flag
        }, function (res) {
            if (!res.error) {
                if (res) {
                    that.setState(prevState => {
                        let tmp = Object.assign({}, prevState);
                        for (let i = 0; tmp && tmp.data && i < tmp.data.length; i++) {
                            if (tmp.data[i] && i === index) {
                                if (type === 3) { //置顶
                                    tmp.data[i].wbtop = flag;
                                    that.state.data[index].wbtopdate = null;
                                    that.state.data[index].wbgotopdate = null;
                                } else if (type === 1) { //头条
                                    tmp.data[i].wbfirst = flag;
                                } else if (type === 2) { //推介
                                    tmp.data[i].wbrecommend = flag;
                                }
                            }
                        }
                        return tmp;
                    });
                    message.info("修改成功");
                    //刷新列表
                    that.reloadTableData();
                } else {
                    message.error("修改失败！");
                }
            } else {
                message.error(res.error);
            }
        })
    }

    /**
     * 打开设置置顶窗口
     * @param story
     */
    setUpTopInfo(index, story, flag) {
        let that = this;
        this.setState({
            modal: {
                ...this.state.modal,
                title: "设置置顶时间",
                visible: true,
                type: "top",
                ModalText: <div><DatePicker
                    key={uuid()}
                    allowEmpty={[false, true]}
                    showTime={{ format: 'HH:mm:ss' }}
                    format="YYYY-MM-DD HH:mm:ss"
                    placeholder={"不设置则立即置顶"}
                    onChange={(value) => {
                        that.state.modal.topInfo.startTime = value ? value.format('YYYY-MM-DD HH:mm:ss') : "";
                    }}
                    disabledDate={(current) => this.disabledStartDate(current)}
                /><span style={{ margin: "0 15px" }}>~</span><DatePicker
                    key={uuid()}
                    allowEmpty={[false, true]}
                    showTime={{ format: 'HH:mm:ss' }}
                    format="YYYY-MM-DD HH:mm:ss"
                    placeholder={"不设置则一直置顶"}
                    onChange={(value) => {
                        that.state.modal.topInfo.endTime = value ? value.format('YYYY-MM-DD HH:mm:ss') : "";
                    }}
                    disabledDate={(current) => this.disabledEndDate(current)}
                /></div>,
                topInfo: {
                    index: index,
                    story: story,
                    flag: flag
                }
            }
        });
    }

    disabledStartDate = current => {
        if (!this.state.modal.topInfo.endTime) {
            return current && (current <= moment().locale("zh-cn").add(-1, "day"));
        }
        return current && ((current <= moment().locale("zh-cn").add(-1, "day"))
          || (current > moment(this.state.modal.topInfo.endTime).locale("zh-cn")));
    };

    disabledEndDate = current => {
        if (!this.state.modal.topInfo.startTime) {
            return current && (current <= moment().locale("zh-cn").add(-1, "day"));
        }
        return current && ((current <= moment().locale("zh-cn").add(-1, "day")) || (current <= moment(this.state.modal.topInfo.startTime).locale("zh-cn").add(-1, "day")));
    };

    range(start, end) {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    }

    /**
     * 修改重要性
     */
    changeInputImportInfo(index, event) {
        //设置当前重要性已被修改，需要保存
        this.state.data[index].wbweightFlag = true;
        let newWbWeight = null;
        if (typeof event === "string" || typeof event === "number") {
            newWbWeight = event;
        } else {
            newWbWeight = event.target.value;
        }
        if (this.state.data[index].news.wbweight === newWbWeight) {
            return;
        }
        /*this.setState(prevState  => {
            let tmp = Object.assign({}, prevState);
            tmp.data[index].wbweight = newWbWeight;
            return tmp;
        });*/
        this.state.data[index].news.wbweight = newWbWeight;
    }

    /**
     * 激活重要性修改窗口
     * @param index
     */
    openInputImportInfo(index) {
        this.state.importInfoSaveButton =
            <Button style={{ marginLeft: "10px" }} onClick={() => this.saveImportInfo()}>保存重要性</Button>;
        if (this.state.data.length > 0) {
            this.state.data[index].wbweightFlag = true;
        }
    }

    /**
     * 打开设置重要性窗口
     * @param story
     */
    setUpImportInfo(story, index) {
        // message.info("story" + story);
        this.setState({
            modal: {
                ...this.state.modal,
                title: "设置重要性",
                visible: true,
                type: "import",
                ModalText: <InputNumber min={0} max={999} defaultValue={story.wbweight ? story.wbweight : 10}
                                        onChange={(value) => {
                                            this.state.modal.importInfo.number = value;
                                            this.state.modal.importInfo.index = index;
                                        }} />,
                importInfo: {
                    story: story,
                    number: story.otherInfo ? story.otherInfo.importInfo : 10
                }
            }
        });
    }

    /**
     * 关闭弹窗
     */
    closeBodyModal() {
        this.setState({
            modal: {
                ...this.state.modal,
                visible: false,
                confirmLoading: false,
                ModalText: null
            }
        });
    }

    getPublicInfo() {
        return {
            mediaCode: this.params.currentMedia,
            treeContentId: this.params.treeContentId,
        }
    }

    handleOk = () => {
        let that = this;
        let publicInfo = this.getPublicInfo();
        //修改的置顶
        if (this.state.modal.type === "top") {
            if (this.state.modal.topInfo.startTime && this.state.modal.topInfo.endTime) {
                if (moment(this.state.modal.topInfo.startTime) >= moment(this.state.modal.topInfo.endTime)) {//如果开始时间晚于结束时间，则提醒
                    message.error("置顶开始时间必须早于结束时间");
                    return;
                }
            }
            this.setState({
                modal: {
                    ...this.state.modal,
                    confirmLoading: true,
                }
            });
            doTop({
                ...publicInfo,
                storyId: this.state.modal.topInfo.story.id,
                toptime: this.state.modal.topInfo.startTime ? this.state.modal.topInfo.startTime : "",
                gotoptime: this.state.modal.topInfo.endTime ? this.state.modal.topInfo.endTime : "",
            }, function (res) {
                if (res) {
                    let index = that.state.modal.topInfo.index;
                    let flag = that.state.modal.topInfo.flag;
                    that.state.data[index].wbtopdate = that.state.modal.topInfo.startTime ? that.state.modal.topInfo.startTime : "";
                    that.state.data[index].wbgotopdate = that.state.modal.topInfo.endTime ? that.state.modal.topInfo.endTime : "";
                    flag = flag === 1 ? 0 : 1;
                    that.setState(prevState => {
                        let tmp = Object.assign({}, prevState);
                        tmp.data[index].wbtop = flag;
                        return tmp;
                    });
                } else {
                    message.error("修改失败！");
                }
                //刷新列表
                that.reloadTableData();
                that.closeBodyModal();
            })
        } else if (this.state.modal.type === "import") {  //重要性
            this.setState({
                modal: {
                    ...this.state.modal,
                    confirmLoading: true,
                }
            });
            setImportance({
                ...publicInfo,
                storyIds: this.state.modal.importInfo.story.id,
                wbweightstr: this.state.modal.importInfo.number
            }, function (res) {
                if (res) {
                    let index = that.state.modal.importInfo.index;
                    that.setState(prevState => {
                        let tmp = Object.assign({}, prevState);
                        tmp.data[index].wbweight = that.state.modal.importInfo.number
                        return tmp;
                    });
                    that.closeBodyModal()
                }
            })
        }
    };


    /**
     * 点取消按钮
     */
    handleCancel = () => {
        this.setState({
            modal: {
                ...this.state.modal,
                visible: false,
            }
        });
    };

    /* 解析发布状态 */
    transformTimeLineItem(str) {
        //模板     "[2019-12-01 17:00:37]开始发布至xx网站/校园新闻",
        //         "[2019-12-01 17:00:38]发布至xx网站/校园新闻成功",
        //         "[2019-12-01 17:00:38]正在发布融媒APP",
        //         "[2019-12-01 17:00:38]发布至融媒APP成功"
        let item = {};
        if (str.indexOf("[") > -1 && str.indexOf("]") > -1) {
            item.time = str.substring(str.indexOf("[") + 1, str.indexOf("]"));
            item.content = str.substring(str.indexOf("]") + 1);
            if (str.indexOf("开始") === str.indexOf("]") + 1) {
                item.type = "start";
            } else if (str.indexOf("正在") === str.indexOf("]") + 1) {
                item.type = "doing";
            } else if (str.indexOf("成功") === str.length - 2) {
                item.type = "ok";
            } else if (str.indexOf("失败") > -1) {
                item.type = "error";
            }
        } else {
            item.type = "none";
            item.time = "";
            item.content = str;
        }
        return item;
    }

    /* 渲染发布状态 */
    renderingPublishStatusTimeLineItem(item) {
        let newSecondSelectColor = this.props.sysConfig && this.props.sysConfig.getValueByKey ? this.props.sysConfig.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        if (item.type === "none") {
            return <Timeline.Item key={uuid()} color={newSecondSelectColor}>
                <p>{item.content}</p>
            </Timeline.Item>;
        } else if (item.type === "start") {
            return <Timeline.Item key={uuid()} color={newSecondSelectColor}>
                <p>{item.time}</p>
                <p>{item.content}</p>
            </Timeline.Item>;
        } else if (item.type === "doing") {
            return <Timeline.Item key={uuid()} color={newSecondSelectColor} dot={<Icon type="clock-circle-o" style={{ fontSize: '16px', color: newSecondSelectColor }} />}>
                <p>{item.time}</p>
                <p>{item.content}</p>
            </Timeline.Item>;
        } else if (item.type === "ok") {
            return <Timeline.Item key={uuid()} color={newSecondSelectColor} dot={<Icon type="check-circle" style={{ fontSize: '16px', color: newSecondSelectColor}} />}>
                <p>{item.time}</p>
                <p>{item.content}</p>
            </Timeline.Item>;
        } else if (item.type === "error") {
            return <Timeline.Item key={uuid()} color={newSecondSelectColor} dot={<Icon type="check-circle" style={{ fontSize: '16px', color: newSecondSelectColor }} />}>
                <p>{item.time}</p>
                <p>{item.content}</p>
            </Timeline.Item>;
        } else {
            return <Timeline.Item key={uuid()} color={newSecondSelectColor} dot={<Icon type="clock-circle-o" style={{ fontSize: '16px', color: newSecondSelectColor }} />}>
                <p>{item.time}</p>
                <p>{item.content}</p>
            </Timeline.Item>;
        }
    }

    /**
     * 组装发布进度信息
     * @param index
     * @returns {*}
     */
    getPopoverContent(index) {
        let timeList = [];
        if (this.state.data[index].publishStatus && this.state.data[index].publishStatus.processStatus && this.state.data[index].publishStatus.processStatus.length > 0) {
            for (let i = 0; i < this.state.data[index].publishStatus.processStatus.length; i++) {
                let temp = this.transformTimeLineItem(this.state.data[index].publishStatus.processStatus[i]);
                timeList.push(this.renderingPublishStatusTimeLineItem(temp));
            }
            return <div style={{ maxHeight: 550, overflowY: "auto", padding: 5 }}>
                <Timeline >
                    {timeList.map(item => item)}
                </Timeline>
            </div>;
        } else {
            return <div>未查询到发布进度</div>;
        }
    }

    /**
     * 组装邮件   收件人信息
     * @returns {*}
     */
    getSendEmailContent(index) {
        let that = this;
        let currentData = this.state.data[index];
        let receivers = this.state.receivers;
        if (!receivers || receivers.length == 0) {
            return <div>没有配置收件人信息</div>
        }
        const children = [];
        for (let i = 0; i < receivers.length; i++) {
            children.push(<Option key={receivers[i].email}>{receivers[i].name}</Option>);
        }

        function handleChange(value) {
            if (value) {
                // let selectReceiver= that.state.selectReceiver;
                // selectReceiver.push(value[0]);
                that.state.selectReceiver = value;
            }
        }

        return <div className={"email"}>
            <div><Button size={"small"} style={{ margin: "5px" }} onClick={() => {
                this.cancelSendEmail()
            }}>取消</Button><Button size={"small"}
                                  style={{ margin: "5px" }}
                                  onClick={() => {
                                      this.okSendEmail(currentData)
                                  }} type="primary">确定</Button></div>
            <div>选择收件人<Select mode="tags" style={{ width: '100%' }} onChange={handleChange} tokenSeparators={[',']}>
                {children}
            </Select></div>
        </div>
    }

    /**
     * 取消按钮事件
     */
    cancelSendEmail() {
        this.setState({
            loading: false,
        })
    }

    /**
     * 发送邮件
     * @param story
     */
    okSendEmail(story) {
        if (!this.state.selectReceiver || this.state.selectReceiver.length == 0) {
            message.error("请选择收件人");
            return;
        }
        //重置标题内容
        const { form } = this.formRef.props;
        form.resetFields();

        this.setState({
            emailVisible: true,
            currentStory: story,
        })
    }

    state = {
        data: [],
        changeSortSwitch: false, //排序开关
        columns: this.columns,  //表头
        loading: false,         //加载
        total: 0,                //总条数
        modal: {                //对话框标题
            title: "",
            ModalText: null,
            confirmLoading: false,
            visible: false,         //置顶对话框是否显示
            topInfo: {
                startTime: new Date(),
                endTime: new Date(),
                id: null
            },
            importInfo: {
                number: null,
                id: null
            }
        },
        selectList: [],          //选中的结果
        selectedRowKeys: [],
        tableHeight: document.body.clientHeight - 326 - 30,//多减个10，防止table出滚动条的时候多处来的高度  再减20 解决ie浏览器下的高度太高导致
        importInfoSaveButton: null,
        popconfirmVisibleIdDefaultTitle: "是否需要撤稿？",
        popconfirmVisibleId: {//控制撤回按钮的气泡
            id: 0,
            show: false,
            title: "是否需要撤稿？"
        },
        publishUserShowFlag: false,
        currentItem: {},
        cancelRelateVisible: {//控制取消关联选题按钮的气泡
            id: 0,
            show: false,

        },
    };
    /* dragSort=this.props.sysConfig && this.props.sysConfig.getValueByKey ? this.props.sysConfig.getValueByKey("pms.column.drag.sort", '0') : '0';
    dragSort=dragSort==='0'?false:true;*/
    publishUserColumns = {
        title: '发布人',
        className: '',
        dataIndex: 'publishUserName',
        key: 'publishUserName',
        align: 'center',
        width: '7%',
        render: (text, record, index) => {
            if (this.state.data[index].publishUserName) {
                return this.state.data[index].publishUserName;
            } else {
                return "";
            }
        }
    }
  

    columns = [//默认表头  不能放在defaultProps中，因为获取不到this
        {
            title: '标题',
            dataIndex: 'title',
            key: 'title',
            //fixed: 'left',
            width:'26%',
            render: (text, record, index) => {
                let newSecondSelectColor = this.props.sysConfig && this.props.sysConfig.getValueByKey ? this.props.sysConfig.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
                return (<div style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    paddingLeft:20
                }}>
                    <a style={{ color:newSecondSelectColor }} onClick={(record.storyType === 1 || record.storyTypeStr === 'PIC') ? () => this.showAtlasStory(record) : () => this.editStory(record)}>{this.state.data[index].title}</a>
                    <div>
                        {
                            record.online ? <span style={{ color: '#ff9900', marginRight: '10px' }}
                                                  title={record.online}>待上线</span> : ""
                        }
                        {
                            record.offline ? <span style={{ color: '#ff9900', marginRight: '10px' }}
                                                   title={record.offline}>已下线</span> : ""
                        }
                        {
                            record.waitTop ? <span style={{ color: '#ff9900' }} title={record.waitTop}>待置顶</span> : ""
                        }
                        {
                            record.cancel ? <span style={{ color: '#ff9900' }} title={record.cancel}>置顶待取消</span> : ""
                        }
                    </div>
                </div>);
            },
            // ellipsis: true   //根据内容自动省略   内容省略搭配 fixed 不起作用
        },
        {
            title: '作者',
            dataIndex: 'author',
            key: 'author',
            align: 'center',
            width: '200px',
        },
        {
            title: '状态',
            dataIndex: 'statusName',
            key: 'statusName',
            width: '150px',
            align: 'center',
            render: (text, record, index) => {
                var temp;
                if (this.state.data[index].dataSource === 8 || (this.state.data[index].statusName === '发布' && this.state.data[index].publishStatus && this.state.data[index].publishStatus.status === 1)) {
                    temp = this.state.data[index].statusName;
                } else if (this.state.data[index].statusName === '发布') {
                    temp = "发布中";
                } else if (this.state.data[index].statusName === '通过') {
                    temp = <div style={{ color: "coral" }}>待处理</div>;
                } else {
                    temp = this.state.data[index].statusName;
                }
                return temp;
            }
        },
        {
            title: '修改时间',
            dataIndex: 'changeDate',
            key: 'changeDate',
            align: 'center',
            width: '140px',
            render: (text, record, index) => {
                return window.formatDate(record.changeDate)
            },
        },
        {
            title: '置顶',
            dataIndex: 'zd',
            key: 'zd',
            width: '50px',
            align: 'center',
            render: (text, record, index) => {
                let possess=record.possess;//权限
                let publish=false;
                if(possess){
                    publish=record.publish
                }
                let storyColumn = this.getCurrentStoryColumn(record);
                let newSecondSelectColor = this.props.sysConfig && this.props.sysConfig.getValueByKey ? this.props.sysConfig.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
                return <Tooltip placement="top"
                                title={this.state.data[index].news.wbtop === 1 ?
                                    <div>
                                        <p>开始时间：{this.state.data[index].news.wbtopdate ? window.formatDate(this.state.data[index].news.wbtopdate) : "不设置则立即置顶"}</p>
                                        <p>结束时间：{this.state.data[index].news.wbgotopdate ? window.formatDate(this.state.data[index].news.wbgotopdate) : "不设置则一直置顶"}</p>
                                        <p>点击取消置顶</p>
                                    </div>
                                    : <div>点击设置置顶</div>
                                }><Icon style={{
                    color: (() => {
                        if (!storyColumn.wbtop) {//如果没有置顶
                            return "darkgray";
                        }
                        if(record.waitTop){
                            return '#ff9900';
                        }
                        if (this.state.data[index].news.wbtopdate && (this.state.data[index].news.wbtopdate.time > new Date().getTime())) {
                            return newSecondSelectColor;
                        }
                        return newSecondSelectColor;
                    })()
                }} onClick={
                    (e) => {
                        if(!publish){
                            message.info('暂无权限操作');
                            return ;
                        }
                        if (storyColumn.wbtop === 1) {
                            this.setUpOtherInfo(index, record.id, 3, storyColumn.wbtop, e)
                        } else {
                            this.setUpTopInfo(index, record, storyColumn.wbtop)
                        }
                    }
                } type="heart" theme="filled" /></Tooltip>
            }
        },
        {
            title: '头条',
            dataIndex: 'wbfirst',
            key: 'wbfirst',
            width: '50px',
            align: 'center',
            render: (text, record, index) => {
                let storyColumn = this.getCurrentStoryColumn(record);
                let possess=record.possess;//权限
                let publish=false;
                if(possess){
                    publish=record.publish
                }
                let newSecondSelectColor = this.props.sysConfig && this.props.sysConfig.getValueByKey ? this.props.sysConfig.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
                return <Tooltip placement="top" title={
                    this.state.data[index].news.wbfirst === 1 ?
                        <div>
                            <p>开始时间：{this.state.data[index].news.wbfirststartdate ? window.formatDate(this.state.data[index].news.wbfirststartdate) : "不设置则立即头条"}</p>
                            <p>结束时间：{this.state.data[index].news.wbfirstenddate ? window.formatDate(this.state.data[index].news.wbfirstenddate) : "不设置则一直头条"}</p>
                            <p>点击取消头条</p>
                        </div>
                        : ((this.state.data[index].news.wbfirstenddate && (this.state.data[index].news.wbfirstenddate.time <= new Date())) ?
                        <div>
                            <p>开始时间：{this.state.data[index].news.wbfirststartdate ? window.formatDate(this.state.data[index].news.wbfirststartdate) : "不设置则立即头条"}</p>
                            <p>结束时间：{this.state.data[index].news.wbfirstenddate ? window.formatDate(this.state.data[index].news.wbfirstenddate) : "不设置则一直头条"}</p>
                            <p>头条时间已过期，请点击该文章标题进入编辑器中重新设置头条</p>
                        </div> : <div>点击设置头条</div>)
                }><Icon style={{
                    color: (() => {
                        if (!storyColumn.wbfirst) {//如果没有头条
                            return "darkgray";
                        }
                        if (this.state.data[index].news.wbfirststartdate && (this.state.data[index].news.wbfirststartdate.time > new Date().getTime())) {
                            return "#ff9900";
                        }
                        return newSecondSelectColor;
                    })()
                }} onClick={
                    (e) => {
                        if(!publish){
                            message.info('暂无权限操作');
                            return;
                        }
                        if ((this.state.data[index].news.wbfirstenddate && (this.state.data[index].news.wbfirstenddate.time <= new Date()))) {
                            message.warn("头条时间已过期，请点击该文章标题进入编辑器中重新设置头条");
                            return;
                        }
                        this.setUpOtherInfo(index, record.id, 1, storyColumn.wbfirst, e)
                    }
                } type="star" theme="filled" /></Tooltip>
            }
        },
        {
            title: '推荐',
            dataIndex: 'wbrecommend',
            key: 'wbrecommend',
            width: '50px',
            align: 'center',
            render: (text, record, index) => {
                let storyColumn = this.getCurrentStoryColumn(record);
                let possess=record.possess;//权限
                let publish=false;
                if(possess){
                    publish=record.publish
                }
                let newSecondSelectColor = this.props.sysConfig && this.props.sysConfig.getValueByKey ? this.props.sysConfig.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
                return <Tooltip placement="top" title={storyColumn.wbrecommend === 1 ? "点击取消推荐" : "点击设置推荐"}><Icon
                    style={{
                        color: storyColumn.wbrecommend === 1 ? newSecondSelectColor : "darkgray"
                    }} onClick={
                    (e) => {
                        if(!publish){
                            message.info('暂无权限操作');
                            return;
                        }
                        this.setUpOtherInfo(index, record.id, 2, storyColumn.wbrecommend, e)
                    }
                } type="like" theme="filled" /></Tooltip>
            }
        },
        {
            title: '重要性',
            dataIndex: 'parts',
            key: 'parts',
            width: '50px',
            align: 'center',
            render: (text, record, index) => {
                let storyColumn = this.getCurrentStoryColumn(record);
                let possess=record.possess;//权限
                let publish=false;
                if(possess){
                    publish=record.publish
                }
                let tooltip = <InputNumber
                    min={1}
                    max={999}
                    key={uuid()}
                    defaultValue={storyColumn.wbweight || 10}
                    // value = {storyColumn.wbweight || 10}
                    style={{ width: 60 }}
                    name={"wbweight"}
                    disabled={!publish}
                    //onChange={(value)=>this.changeInputImportFlag(index,value)}
                    onBlur={(event) => this.changeInputImportInfo(index, event)}
                    onPressEnter={(event) => this.changeInputImportInfo(index, event)}
                />;
                return tooltip;
            }
        },
        {
            title: '操作',
            dataIndex: 'event',
            key: 'event',
            // fixed: 'right',
            width: '300px',
            // align: 'center',
            render: (text, record, index) => {
                let possess=record.possess;//权限
                let buttonList = [];
                buttonList.push(
                    <Button key={uuid()} size={"small"} type="primary" style={{ marginRight: "5px", marginBottom: '10px' }}
                            onClick={() => window.preview(record.id, this.params.treeContentId)}>预览</Button>
                );
                let revert=false;
                if(possess){
                    revert=record.publish
                }
                revert=true;
                console.log(this.state.popconfirmVisibleId.show && (this.state.popconfirmVisibleId.id == record.id))
				if ((this.state.data[index].statusName === "发布" && this.state.data[index].dataSource !== 8 && this.state.data[index].publishStatus) || this.state.data[index].online) {
					buttonList.push(
						<Popconfirm key={index} placement="topLeft"
									visible={
                                        record.open
									    /*(() => {
										return this.state.popconfirmVisibleId.show && (this.state.popconfirmVisibleId.id == record.id)
									})()*/
									}
                                    disabled={!revert}
									title={this.state.popconfirmVisibleId.title}
									onConfirm={() => {
                                        record.open=false;
										this.setState({
											popconfirmVisibleId: {
												id: 0,
												show: false,
												title: this.state.popconfirmVisibleIdDefaultTitle
											}
										})
										this.callBackConfirm(this.state.data[index], index);
									}}
									onCancel={() => {
                                        record.open=false;
										this.setState({
											popconfirmVisibleId: {
												id: 0,
												show: false,
												title: this.state.popconfirmVisibleIdDefaultTitle
											}
										})
									}}
									okText="是" cancelText="否">
							<Button size={"small"}
                                    disabled={!revert}
									onClick={() => {
										getStoryById(record.id, (story) => {
										    record.open=true;
											this.setState({
												popconfirmVisibleId: {
													id: record.id,
													//show: true,
													title: (() => {
														if (story && story.news && story.news.length > 1) {
															return "检查到该文章同时发布到了多个栏目，撤稿操作会将多个栏目下的文章同时撤稿，确定要全部撤稿吗？";
														}
														return this.state.popconfirmVisibleIdDefaultTitle;
													})()
												}
											})
										})
									}}
									style={{ marginRight: "5px" }}>撤稿</Button>
						</Popconfirm>
					);
				}
                if (this.state.data[index].statusName === "发布"||this.state.data[index].statusName === "发布失败") {
                    buttonList.push(
                        <Popover key={uuid()} placement="leftTop" title={"发布进度"} content={this.getPopoverContent(index)}
                                 trigger="click">
                            <Button size={"small"} style={{ marginRight: "5px" }}>发布进度</Button>
                        </Popover>
                    );

                    //判断是否开启了邮箱功能，发邮件
                    if (this.state.openEmail) {
                        buttonList.push(
                            <Popover key={uuid()} placement="leftTop" title={"发邮件"}
                                     content={this.getSendEmailContent(index)} trigger="click">
                                <Button size={"small"} style={{ marginRight: "5px" }} onClick={() => { this.state.selectReceiver = [] }}>发邮件</Button>
                            </Popover>
                        );
                    }
                }
                let deleteAuth=false;
                if(possess){
                    deleteAuth=record.publish
                }
                    // false 是可以操作，所以取反
                if ((this.state.data[index].statusName === "草稿" && this.state.data[index].submitter === this.props.currentUser.account) || this.state.data[index].statusName === "撤稿") {
                    buttonList.push(
                        <Popconfirm disabled={!deleteAuth} key={uuid()} placement="topLeft" title={"删除稿件后无法还原，您确定要删除吗？"}
                                    onConfirm={() => this.deleteRow(this.state.data[index], index)} okText="是"
                                    cancelText="否">
                            <Button disabled={!deleteAuth} size={"small"} style={{ margin: "5px" }}>删除</Button>
                        </Popconfirm>
                    );
                }

                if (record.topicSelectionId) {  //当前已经有关联选题
                    //选题没被采用不允许查看关联选题
                        buttonList.push(
                            <Button key={uuid()} size={"small"} style={{ marginRight: 5, marginBottom: 10 }} onClick={() => {
                                if (record.topicSelectionId) {
                                    this.RelationSelectTopicDetail.selectTopicDetailDetailShow(record.topicSelectionId)
                                }
                            }}>查看关联选题</Button>
                        )

                    buttonList.push(
                        <Popconfirm
                            title="请确认是否取消关联选题"
                            key={uuid()}
                            onConfirm={() => {
                                this.cancelTopic()
                            }}
                            onCancel={() => {
                                this.setState({
                                    cancelRelateVisible: {
                                        id: 0,
                                        show: false,
                                    }
                                })
                            }}
                            okText="确认"
                            cancelText="取消"
                            visible={this.state.cancelRelateVisible.show && (this.state.cancelRelateVisible.id === record.id)}
                        >
                            <Button  size={"small"} style={{ marginRight: 5 }} onClick={() => { this.setState({ currentItem: record, cancelRelateVisible: { id: record.id, show: true} }) }}>取消关联选题</Button>
                        </Popconfirm>
                    )
                }
                if (!record.topicSelectionId) {
                    buttonList.push(
                        <Button key={uuid()} size={"small"} style={{ marginRight: 5 }} onClick={() => { this.setState({ currentItem: record }); this.SelectManuscriptPool.showTask({ taskTitle: '关联选题', topBtn: true }) }} >关联选题</Button>

                    )
                }

                /*
                if(this.state.data[index].statusName === "撤稿")
                {
                    buttonList.push(
                        <Popconfirm key={uuid()} placement="topLeft" title={"稿件还原后为草稿状态，需要重新发布，您确定要将此稿件还原为草稿吗？"} onConfirm={()=>this.restore(this.state.data[index],index)} okText="是" cancelText="否">
                            <Button size={"small"} style={{margin:"5px"}} >还原</Button>
                        </Popconfirm>
                    );
                }
                */
                return (
                    <div>{buttonList.map(item => item)}</div>
                )
            }
        }
    ];


    //新增删除选择modal
    renderModal() {
        return (
            <div>
                <Modal
                    title="稿件中还包含以下文件，请勾选对应文件从资源库删除"
                    visible={this.state.deletesVisible}
                    onOk={() => {
                    }}
                    onCancel={() => {
                        this.setState({ deletesVisible: false })
                    }}
                    width={500}
                    bodyStyle={{ height: 500 }}
                  /*  getContainer={false}*/
                    footer={
                        <div>
                            <Button onClick={() => {
                                this.noDelete()
                            }} type="primary" loading={this.state.btnLoadingStatus}>全都不删除</Button>
                            <Button onClick={() => {
                                this.deleteAll()
                            }} type="primary" loading={this.state.btnLoadingStatus}>全删除</Button>
                            <Button loading={this.state.btnLoadingStatus} onClick={() => {
                                this.deleteChoose()
                            }} type="primary">仅删除勾选</Button>
                        </div>
                    }
                >
                    <div style={{ width: 452, height: 452 }}>
                        <Scrollbars>
                            <div style={{ overflow: 'hidden' }}>
                                {this.state.deleteSources.map((item, i) => {
                                    if (item.ext === 'jpg' || item.ext === 'jpeg' || item.ext === 'JPG' || item.ext === 'JPEG' ||
                                        item.ext === 'png' || item.ext === 'PNG' || item.ext === 'gif' || item.ext === 'GIF') {
                                        return (
                                            <div key={i} title={item.name} onClick={() => {
                                                this.itemClick(item, i)
                                            }} style={{
                                                float: 'left',
                                                padding: 10,
                                                marginLeft: 10,
                                                marginTop: 10,
                                                background: item.checked ? '#0050B3' : null
                                            }}>
                                                <div><img style={{ height: 80, width: 80, objectFit: 'cover' }}
                                                          src={item.path} alt="" /></div>
                                                <div title={item.name} style={{
                                                    textAlign: 'center',
                                                    width: 80,
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                }}>{item.name}</div>
                                            </div>
                                        )
                                    } else {
                                        return (
                                            <div key={i} title={item.name} onClick={() => {
                                                this.itemClick(item, i)
                                            }} style={{
                                                float: 'left',
                                                padding: 10,
                                                marginLeft: 10,
                                                marginTop: 10,
                                                background: item.checked ? '#0050B3' : null
                                            }}>
                                                <div><Icon style={{ fontSize: 80 }} type="file" /></div>
                                                <div title={item.name} style={{
                                                    textAlign: 'center',
                                                    width: 80,
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                }}>{item.name}</div>
                                            </div>
                                        )
                                    }

                                })}
                                <div style={{ clear: 'both' }} />
                            </div>
                        </Scrollbars>
                    </div>
                </Modal>
            </div>
        )
    }

    itemClick(record, i) {
        this.setState(prevState => {
            prevState.deleteSources[i].checked = !record.checked;
            return prevState;
        })
    }

    //全都不删除
    noDelete() {
        this.setState({
            btnLoadingStatus: true
        });
        this.deleteStoryById()//删除数据
    }

    //删除全部
    deleteAll() {
        this.setState({
            btnLoadingStatus: true
        });
        let MD5S = [];
        this.state.deleteSources.forEach(item => {
            let md5 = item.path.replace(/\/storage\/([a-zA-Z0-9]{32}).*!/, "$1");
            MD5S.push(md5);
        });

        //调用删除接口
        delMoveFileToRecycle({ fileMd5s: MD5S.join(',') }, (data => {
        }));

        this.deleteStoryById();//删除数据

    }

    //删除勾选
    deleteChoose() {
        this.setState({
            btnLoadingStatus: true
        });
        let MD5S = [];
        this.state.deleteSources.forEach(item => {
            if (item.checked) {
                let md5 = item.path.replace(/\/storage\/([a-zA-Z0-9]{32}).*/, "$1");
                MD5S.push(md5);
            }
        });
        delMoveFileToRecycle({ fileMd5s: MD5S.join(',') }, (data => {

        }));
        this.deleteStoryById();//删除数据
    }

    getCurrentStoryColumn = (record) => {
        return record.news || {};
    };

    //在组件接收到一个新的 prop (更新后)时被调用
    componentWillReceiveProps(_newProps) {
        if (_newProps.currentUser && _newProps.params && this.params !== _newProps.params) {
            if (_newProps.params.columns) {
                this.setState({
                    columns: this.props.columns,
                });
            }
            this.initData({
                ...this.params,
                ..._newProps.params,
                start: 1,
                size: 10
            });
        }
        if (_newProps.sysConfig) {
            let temp = _newProps.sysConfig.getValueByKey("pms.publish.publishUserShow") && _newProps.sysConfig.getValueByKey("pms.publish.publishUserShow") === "1" ? true : false;
            this.state.publishUserShowFlag = temp;
            this.setState({
                columns: this.columns,
                publishUserShowFlag: temp
            })
        }
        if (this.params !== _newProps.params) {
            this.params = {
                ...this.params,
                ..._newProps.params,
                start: 1,
                size: 10
            };
        }
    }


    /* 撤稿 */
    storyCallBack(record, index) {
        let that = this;
        undo({
            mediaCode: this.params.currentMedia,
            storyId: record.id
        }, function (res) {
            if (res && res.code === 0 || res.code === "0") {
                message.info("撤稿成功！");
            } else if (res.msg) {
                message.error(res.msg);
            }
            //刷新列表
            that.reloadTableData();
        })
    }


    /* 编辑 */
    editStory(record) {
        let actButtonId = 2;
        // eslint-disable-next-line no-undef
        let that = this;
        getStoryType({ storyId: record.id }, function (res) {
            if (res === "fzr") {
                actButtonId = 6;
            } else if (res === "unfzr") {
                actButtonId = 5;
            } else if (res === "yuegao") {
                actButtonId = 4;
            }
            let interviewId = record.interviewId || 0;
            let url = "/cm-sites/pms/addContribute/addContributeNews.html?interviewId=" +interviewId+ "&eiditStoryId=" + record.id + "&currentMediaCode=" + that.params.currentMedia + "&actButtonId=" + actButtonId + "&treeId=" + that.params.treeId + "&treeContentId=" + that.params.treeContentId;
            if (record.statusName === "通过")
                url += "&fromZyk=true";
            window.openFull(url, record.title, null, {
                shade: 0.5,
                area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
            }, null,function () {
                that.reloadTableData();
            })
        });
    }


    initData(params) {
        let that = this;
        that.setState({
            loading: true,
            selectList: [],
            selectedRowKeys: []
        });
        let getMediaRoleByColumParams=[{mediaCode:params.currentMedia,mediaTreeId:params.treeContentId,activitiTypeEnum:"DEFAULT"}];
        getMediaRoleByColum(getMediaRoleByColumParams,res=>{
            // console.log(res)
            let authRol=res;
            postPublic(this.props.url, params || this.props.params, (data) => {
                let newDate=data.data;
                let  newDataRol=[];
                newDate.forEach(item=>{
                    newDataRol.push({
                        ...item,
                        possess:authRol.possess,
                        edit:authRol.edit,
                        publish:authRol.publish,
                        revert:authRol.revert,
                        delete:authRol.delete,
                    })
                });

                that.setState({
                    data: newDataRol,
                    total: data.count,
                    loading: false
                });
                that.prevData = newDataRol;
                let obj = document.getElementsByClassName("ant-table-body")[0];
                if (obj.scrollHeight > obj.clientHeight || obj.offsetHeight > obj.clientHeight) {
                    document.getElementsByClassName("ant-table-header")[0].style.overflowY = 'scroll'
                } else {
                    document.getElementsByClassName("ant-table-header")[0].style.overflowY = 'hidden'
                }
            });
        });
    }

    moveRow = (dragIndex, hoverIndex) => {
        const { data } = this.state;
        const dragRow = data[dragIndex];
        let newState = update(this.state, {
            data: {
                $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
            },
        });
        this.setState(newState);
    };

    prevData;//排序之前的数据

    /**
     * 改变排序
     */
    changeSort = () => {
        let that = this;
        if (that.state.changeSortSwitch && that.prevData !== that.state.data) {
            that.setState({
                loading: true
            });
            let newSorts = that.gotoStorySort(that.prevData, that.state.data);
            storySort(newSorts, function (res) {
                let tempData = that.state.data;
                for (let i = 0; i < tempData.length; i++) {
                    tempData[i].orderField = res[tempData[i].id];
                }
                that.prevData = tempData;
                that.setState({
                    changeSortSwitch: !that.state.changeSortSwitch,
                    data: tempData,
                    loading: false
                });
            });
        } else {
            that.setState({
                changeSortSwitch: !that.state.changeSortSwitch
            })
        }
    };

    /**
     * 将顺序重新组合
     * @param oldData
     * @param newData
     * @returns {[]}
     */
    gotoStorySort = (oldData, newData) => {
        let newIds = [];
        for (let i = 0; i < newData.length; i++) {
            newIds.push(newData[i].id);
        }
        let newSorts = [];
        for (let i = 0; i < oldData.length; i++) {
            newSorts.push({
                id: newIds[i],
                orderField: oldData[i].orderField || oldData[i].submitDate.time
            });
        }
        return newSorts;
    };

    // onSelect = (record, selected, selectedRows, nativeEvent) => {
    //     this.setState({
    //         selectList: selectedRows
    //     })
    // };
    //
    // onSelectAll = (selected, selectedRows, changeRows) => {
    //     this.setState({
    //         selectList: selectedRows
    //     })
    // };
    //
    // onSelectedChange =(selectedRowKeys, selectedRows) => {
    //     this.setState({ selectedRowKeys })
    // }
    singleAddStory = () => {
        let url = "/cm-sites/pms/addContribute/addContributeNews.html?currentMediaCode=" + this.params.currentMedia + "&actButtonId=2&treeContentId=" + this.params.treeContentId + "&treeId=" + this.params.treeId;
        let that = this;
        window.openFull(url, "新建稿件", null, {
            shade: 0.5,
            area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
        }, null,function () {
            that.reloadTableData();
        })
};

    addStory = () => {
        //let _this = this;

        confirm({
            title: '提示',
            content: (
                <div>
                    <p>同时创建选题？</p>
                </div>
            ),
            okText: '确定',
            cancelText: '跳过',
            onCancel: () => {
                let url = "/cm-sites/pms/addContribute/addContributeNews.html?currentMediaCode=" + this.params.currentMedia + "&actButtonId=2&treeContentId=" + this.params.treeContentId + "&treeId=" + this.params.treeId;
                let that = this;
                window.openFull(url, "新建稿件", null, {
                    shade: 0.5,
                    area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
                }, null,function () {
                    that.reloadTableData();
                })
            },
            onOk: () => {
                this.addTopicRef.current.changeVisible(true);
            },
        });
    };

    //创建选题后关联写作
    jumpStory = (data) => {
        let url = "/cm-sites/pms/addContribute/addContributeNews.html?currentMediaCode=" + this.params.currentMedia + "&actButtonId=2&treeContentId=" + this.params.treeContentId + "&treeId=" + this.params.treeId + "&topicSelectionId=" + data.id;
        let that = this;
        window.openFull(url, "新建稿件", null, {
            shade: 0.5,
            area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
        }, null,function () {
            that.reloadTableData();
        })
    }

    //关联选题
    relateTopic = (data) => {
        let currentItem = this.state.currentItem;
        let body = {
            storyId: currentItem.id,//稿件id
            bindId: data.id,//选题id
            type: 'topicSelection',
            isbind: true//绑定还是解绑
        };
        this.actions.originalStoryBindOrUnbind(body, data => {
            this.reloadTableData();
        });
    }

    //取消关联选题
    cancelTopic = () => {
        let currentItem = this.state.currentItem;
        let body = {
            storyId: currentItem.id,//稿件id
            bindId: currentItem.topicSelectionId,//选题id
            type: 'topicSelection',
            isbind: false//绑定还是解绑
        };
        this.actions.originalStoryBindOrUnbind(body, data => {
            this.reloadTableData();//刷新列表
            this.setState({
                cancelRelateVisible: {
                    id: 0,
                    show: false,
                }
            })
        });

    }

    addAtlas = () => {
        let url = "/cm-sites/pms/addContribute/atlasdetail.html?currentMediaCode=" + this.params.currentMedia + "&treeId=" + this.params.treeId + "&treeContentId=" + this.params.treeContentId;
        let that = this;
        window.openFull(url, "新建组图", null, {
            shade: 0.5,
            area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
        }, null, function () {
            that.reloadTableData();
        })
    };

    publish = () => {
        if (this.state.selectList) {

        }
    };
    // callBackStory = () => {
    //     let businessIds = [];
    //     let that = this;
    //     if(!this.state.selectList || this.state.selectList.length === 0){
    //         message.error("未选择!");
    //         return;
    //     }
    //     for(let i  = 0 ; i < this.state.selectList.length ; i ++ ){
    //         businessIds.push(this.state.selectList[i].id);
    //     }
    //     undo({
    //         mediaCode: this.params.currentMedia,
    //         businessIds: businessIds.join("|")
    //     },function(res){
    //         if(res && res.code === 0 || res.code === "0"){
    //             message.info("撤稿成功！");
    //             //刷新列表
    //             that.reloadTableData();
    //         }else{
    //             message.error(res.msg || "撤稿失败");
    //         }
    //     })
    // };

    showButton = () => {
        let newSecondSelectColor = this.props.sysConfig && this.props.sysConfig.getValueByKey ? this.props.sysConfig.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        if (!this.props.showBtnArea)
            return;
        let buttonList = [];
        let dragSort=this.props.sysConfig && this.props.sysConfig.getValueByKey ? this.props.sysConfig.getValueByKey("pms.column.drag.sort", '0') : '0';
        dragSort=dragSort==='0'?false:true;
        buttonList.push(<>
        {/* <Button key={uuid()} type="primary" onClick={this.addStory}>新增文章</Button> */}
        <div style={{float:"left"}}>
            <div style={{display:"flex",}}>
                <div key={uuid()} onClick={this.singleAddStory}style={{borderRadius:"4px",borderTopRightRadius:"0px",borderBottomRightRadius:"0px",cursor:"pointer", width:"80px",height:"32px",lineHeight:"32px",color:"#fff",textAlign:"center",backgroundColor:newSecondSelectColor,padding:"0px 10px"}}>新增文章</div>
                <div key={uuid()} onClick={this.addStory} style={{width:"27px",height:"32px",cursor:"pointer",color:"#fff",borderRadius:"4px",marginLeft:"1px",textAlign:"center",borderTopLeftRadius:"0px",borderBottomLeftRadius:"0px",backgroundColor:newSecondSelectColor}}>...</div>
            </div>           
        </div>
          <style>
            {`
.ant-btn-primary{

background-color:${newSecondSelectColor} !important;
border-color:${newSecondSelectColor} !important;
}
             `}</style></>);

        buttonList.push(<Button key={uuid()} type="primary" style={{ marginLeft: "10px" }}
                                onClick={this.addAtlas}>新增组图</Button>);
        if(dragSort){
            buttonList.push(<Button key={uuid()} style={{marginLeft:"10px"}} type="primary" onClick={this.changeSort}>{!this.state.changeSortSwitch?"拖动排序":"完成排序"}</Button>);
        }else {
            buttonList.push(<Button key={uuid()} type="primary" style={{ marginLeft: "10px" }}
                                    onClick={this.saveImportInfo.bind(this)}>保存重要性</Button>);
        }
        // buttonList.push(<Button style={{marginLeft:"10px"}} onClick={this.publish}>发布</Button>);

        /*buttonList.push(<Button key={uuid()} style={{marginLeft:"10px"}} onClick={this.callBackStory}>撤稿</Button>);*/
        /*
        if(this.props.params.name === "草稿箱" || this.props.params.name === "已撤稿")
        {
            buttonList.push(
                <Popconfirm key={uuid()} placement="topLeft" title={"删除稿件后无法还原，您确定要删除吗？"} onConfirm={()=>this.deleteAllStory} okText="是" cancelText="否">
                    <Button style={{marginLeft:"10px"}} >删除</Button>
                </Popconfirm>
            );
        }
         */
        buttonList.push(<Button key={uuid()} style={{ marginLeft: "10px" }} onClick={this.reloadTableData}>刷新</Button>);
        buttonList.push(<Search key={uuid()} placeholder="请输入搜索内容..."
                                style={{ width: "200px", float: "right", marginRight: "20px" }}
                                onSearch={value => this.searchStory(value)} defaultValue={this.params.queryStr || ""}
                                enterButton />);
        buttonList.push(<a key={uuid()} onClick={() => this.websiteDomainURL(this.props)}
                           style={{ float: "right", marginRight: "10px", marginTop: "5px", color: newSecondSelectColor}}>{"访问网站"}</a>);
        buttonList.push(<a key={uuid()} onClick={() => this.vsbDomainURL(this.props)}
                           style={{ float: "right", marginRight: "10px", marginTop: "5px", color: newSecondSelectColor }}>{"网站管理"}</a>);

        return <div style={{ backgroundColor: "white", margin: "15px" }}>
            {buttonList.map(item => item)}
        </div>
    };

    vsbDomainURL(record) {
        judgeBindVsbAccountdo({
            account: record.currentUser.account,
            mediaCode: record.params.currentMedia
        }, function (res) {
            if (res) {
                loginVsbdo({
                    account: record.currentUser.account,
                    mediaCode: record.params.currentMedia
                }, function (res) {
                    window.openLoginPage(res.url, res.account, res.token, res.action);
                });
            } else {
                message.info("当前账号尚未绑定网站群账号");
            }
        });

    }

    websiteDomainURL(record) {
        websiteDomainURLdo({
            mediaCode: record.params.currentMedia
        }, function (res) {
            window.open(res);
        });
    }

    pageChange = (page, pageSize) => {
        this.params = {
            ...this.params,
            start: page,
            size: pageSize
        };
        this.initData(this.params);
    };

    onShowSizeChange = (current, size) => {
        this.params = {
            ...this.params,
            start: current,
            size: size
        };
        this.initData(this.params);
    };

    showAtlasStory = (story) => {
        let url = "/cm-sites/pms/addContribute/atlasdetail.html?currentStoryId=" + story.id + "&currentMediaCode=" + this.params.currentMedia + "&treeId=" + this.params.treeId + "&treeContentId=" + this.params.treeContentId;
        let that=this;
        window.openFull(url, "编辑组图", null, {
            shade: 0.5,
            area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
        },null, function () {
            that.reloadTableData();
        })
    };

    handleEmailCancel = () => {
        this.setState({ emailVisible: false, currentStory: {} });
    };

    handleEmailCreate = () => {
        this.setState({
            confirmLoading: true,
        })
        let that = this;
        const { form } = this.formRef.props;
        var title = form.getFieldValue("emailTitle");
        var emailContent = form.getFieldValue("emailContent");

        let param = {
            storyId: this.state.currentStory.id,
            receivers: this.state.selectReceiver.join(','),
            emailTitle: title,
            emailContent: emailContent,
        }
        sendEmail(param, function () {
            message.success("发送成功", 1, function () {
                that.setState({
                    emailVisible: false,
                    confirmLoading: false,
                    currentStory: {},
                    selectReceiver: []
                })
            });
        });
    };

    saveFormRef = formRef => {
        this.formRef = formRef;
    };

    render() {
        const { visible, confirmLoading, ModalText } = this.state.modal;
        let newSecondSelectColor = this.props.sysConfig && this.props.sysConfig.getValueByKey ? this.props.sysConfig.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';

        let DragableBodyRow = DropTarget(this.state.changeSortSwitch ? "row" : "rowFalse", rowTarget, (connect, monitor) => ({
            connectDropTarget: connect.dropTarget(),
            isOver: monitor.isOver(),
        }))(
            DragSource('row', rowSource, connect => ({
                connectDragSource: connect.dragSource(),
            }))(BodyRow),
        );

        let components = {
            body: {
                row: DragableBodyRow,
            },
        };

        let tempColumns = [];
        //先将发布人栏目排除
        this.columns.map((value, number) => {
            if (value.key !== "publishUserName") {
                tempColumns.push(value);
            }
        });
        //如果需要字段再加上
        if (this.state.publishUserShowFlag) {
            let temp1 = tempColumns.splice(0, 1);
            temp1.push(this.publishUserColumns);
            let temp2 = tempColumns.splice(0, this.columns.length);
            tempColumns = temp1.concat(temp2);
        }

        let dragSort=this.props.sysConfig && this.props.sysConfig.getValueByKey ? this.props.sysConfig.getValueByKey("pms.column.drag.sort", '0') : '0';
        dragSort=dragSort==='0'?false:true;
        console.log(dragSort);
        let newTempColumns=[];
       if(dragSort){
           tempColumns.forEach(item=>{
               if(item.title!=='重要性'){
                   newTempColumns.push(item)
               }
           })
        }else{
           newTempColumns=tempColumns;
       }
        let currentFontSize='14px';
        let currentPadding='5px';
        let currentHeight='30px';
        let currentBtnMargin='5px';
        return (
            <div>
                {this.renderModal()}
                {this.showButton()}
                <div id={'bodyRowTable'}>
                    <style>
                        {`
                       #bodyRowTable .ant-table {
                       font-size:${currentFontSize} !important;
                       }
                       #bodyRowTable .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
                         padding: ${currentPadding} !important; 
                    }
                     #bodyRowTable .ant-input-number{
                       // height:${currentHeight}!important; 
                         font-size:${currentFontSize} !important;
                     }
                     #bodyRowTable  .ant-btn-sm{
                     margin:${currentBtnMargin}!important; ;
                     padding: 0 7px;
                    font-size: ${currentFontSize} !important;
                     }
                        `
                        }
                    </style>
                {
                    dragSort   ?(this.state.changeSortSwitch?<DndProvider backend={HTML5Backend}>
                            <Table
                                scroll={{ x: 1450, y: this.state.tableHeight }}
                                bodyStyle={{ backgroundColor: "white" }}
                                position={"top"}
                                rowKey={record => record.id}
                                key={this.params.treeId + "_" + this.params.treeContentId}
                                pagination={{
                                    showQuickJumper: true,
                                    current: this.params.start,
                                    total: this.state.total,
                                    onChange: this.pageChange,
                                    style: { marginRight: '20px' },
                                    showTotal: total => `共 ${total} 条数据`,
                                    showSizeChanger: true,
                                    pageSizeOptions: ['10', '20', '30', '40'],
                                    onShowSizeChange: this.onShowSizeChange
                                }}
                                columns={newTempColumns}
                                dataSource={this.state.data}
                                components={components}
                                loading={this.state.loading}
                                // rowSelection={{
                                //     onSelect: this.onSelect,
                                //     onSelectAll: this.onSelectAll,
                                //     selectedRowKeys: this.state.selectedRowKeys,
                                //     onChange: this.onSelectedChange
                                // }}
                                onRow={(record, index) => ({
                                    index,
                                    moveRow: this.moveRow,
                                })}
                                style={{
                                    cursor: dragSort?"pointer":"none"
                                }}
                            />
                        </DndProvider>: <Table
                            scroll={{ x: 1450, y: this.state.tableHeight }}
                            bodyStyle={{ backgroundColor: "white" }}
                            position={"top"}
                            rowKey={record => record.id}
                            key={this.params.treeId + "_" + this.params.treeContentId}
                            pagination={{
                                showQuickJumper: true,
                                current: this.params.start,
                                total: this.state.total,
                                onChange: this.pageChange,
                                style: { marginRight: '20px' },
                                showTotal: total => `共 ${total} 条数据`,
                                showSizeChanger: true,
                                pageSizeOptions: ['10', '20', '30', '40'],
                                onShowSizeChange: this.onShowSizeChange
                            }}
                            columns={newTempColumns}
                            dataSource={this.state.data}
                            /* components={components}*/
                            loading={this.state.loading}
                            // rowSelection={{
                            //     onSelect: this.onSelect,
                            //     onSelectAll: this.onSelectAll,
                            //     selectedRowKeys: this.state.selectedRowKeys,
                            //     onChange: this.onSelectedChange
                            // }}
                            /*  onRow={(record, index) => ({
                                  index,
                                  moveRow: this.moveRow,
                              })}*/
                            style={{
                            }}
                        />)
                        :  <Table
                            scroll={{ x: 1450, y: this.state.tableHeight }}
                            bodyStyle={{ backgroundColor: "white" }}
                            position={"top"}
                            rowKey={record => record.id}
                            key={this.params.treeId + "_" + this.params.treeContentId}
                            pagination={{
                                showQuickJumper: true,
                                current: this.params.start,
                                total: this.state.total,
                                onChange: this.pageChange,
                                style: { marginRight: '20px' },
                                showTotal: total => `共 ${total} 条数据`,
                                showSizeChanger: true,
                                pageSizeOptions: ['10', '20', '30', '40'],
                                onShowSizeChange: this.onShowSizeChange
                            }}
                            columns={newTempColumns}
                            dataSource={this.state.data}
                           /* components={components}*/
                            loading={this.state.loading}
                            // rowSelection={{
                            //     onSelect: this.onSelect,
                            //     onSelectAll: this.onSelectAll,
                            //     selectedRowKeys: this.state.selectedRowKeys,
                            //     onChange: this.onSelectedChange
                            // }}
                          /*  onRow={(record, index) => ({
                                index,
                                moveRow: this.moveRow,
                            })}*/
                            style={{
                            }}
                        />
            }
                </div>

                <Modal
                    title={this.state.modal.title}
                    visible={visible}
                    onOk={this.handleOk}
                    confirmLoading={confirmLoading}
                    onCancel={this.handleCancel}
                >
                    {ModalText}
                </Modal>
                <CollectionCreateForm
                    confirmLoading={this.state.confirmLoading}
                    wrappedComponentRef={this.saveFormRef}
                    initData={this.state.currentStory}
                    visible={this.state.emailVisible}
                    onCancel={this.handleEmailCancel}
                    onCreate={this.handleEmailCreate}
                />
                <SelectManuscriptPool newSecondSelectColor={newSecondSelectColor}
                                      ref={SelectManuscriptPool => this.SelectManuscriptPool = SelectManuscriptPool}
                                      callBack={(data) => {
                                          this.relateTopic(data)
                                          //   if (data.topBtn) {
                                          //       if (data.taskTitle === '关联任务') {
                                          //           this.topTask(data)
                                          //       } else {
                                          //           this.topChooseTopic(data)
                                          //       }
                                          //   } else {
                                          //       if (data.taskTitle === '关联任务') {
                                          //           this.itemTask(data)
                                          //       } else {
                                          //           this.itemChooseTopic(data)
                                          //       }
                                          //   }
                                      }} />
                <AddTopic ref={this.addTopicRef} callBack={(data) => this.jumpStory(data)} />
                <RelationSelectTopicDetail
                    ref={RelationSelectTopicDetail => this.RelationSelectTopicDetail = RelationSelectTopicDetail} />
            </div>
        );
    }


    searchStory(value) {
        this.params.queryStr = value;
        this.params.start = 1;
        this.initData(this.params);
    }

    reloadTableData = () => {
        this.initData({
            ...this.params,
        });
    };

    callBackConfirm(obj, index) {
        this.storyCallBack(obj, index);
    }

    /**
     * 还原稿件到草稿箱
     */
    restore(record, index) {
        let that = this;
        restoredo({
            mediaCode: this.params.currentMedia,
            businessIds: record.id
        }, function (res) {
            if (res && res.code === 0 || res.code === "0") {
                message.info("还原成功！");
                //刷新列表
                that.reloadTableData();
            } else if (res.msg) {
                message.error(res.msg);
            }
        });
    }

    /**
     * 彻底删除所选稿件
     */
    deleteAllStory = () => {
        let businessIds = [];
        let that = this;
        if (!this.state.selectList || this.state.selectList.length === 0) {
            message.error("未选择!");
            return;
        }
        for (let i = 0; i < this.state.selectList.length; i++) {
            businessIds.push(this.state.selectList[i].id);
        }

        deletestorydo({
            businessIds: businessIds.join("|")
        }, function (res) {
            if (res) {
                message.info("删除成功！");
                //刷新列表
                that.reloadTableData();
            } else {
                message.error("删除失败！");
            }
        });
    }

    /**
     * 彻底删除单个稿件
     */

    deleteRow(record) {
        this.state.stateRecord = record;
        getresources(record.id, (data) => {
            if (data && data.length > 0) {
                data.forEach(item => {
                    item.checked = false;
                });
                this.setState({
                    deletesVisible: true,
                    deleteSources: data
                })
            } else {
                this.deleteStoryById();
            }

        })
    }
    deleteStoryById() {
        let record = this.state.stateRecord;
        let that = this;
        deletestorydo({
            businessIds: record.id
        }, function (res) {
            if (res) {
                message.info("删除成功！");
                if (that.state.data.length == 1) {//如果当前页面中数据只有一条，
                    if (that.state.data[0].id == record.id) {//并且还给删除了
                        if (that.params.start != 1) {//往前翻一页还得看看是不是第一页，如果不是第一页才往前翻一页
                            that.params.start -= 1;
                        }
                    }
                }
                that.state.btnLoadingStatus = false;
                that.state.deletesVisible = false;
                //刷新列表
                that.reloadTableData();
            } else {
                message.error("删除失败！");
            }
        });
    }

    /**
     * 将修改过的重要性集中保存
     */
    saveImportInfo() {
        if (this.state.data.length > 0) {
            //找到修改过重要性的数据集合
            let changeImportInfoListIds = [];
            let changeImportInfoListWbweights = [];
            for (let i = 0; i < this.state.data.length; i++) {
                if (this.state.data[i].wbweightFlag) {
                    changeImportInfoListIds.push(this.state.data[i].id);
                    changeImportInfoListWbweights.push(this.state.data[i].news.wbweight);
                }
            }
            if (changeImportInfoListIds.length > 0 && changeImportInfoListIds.length === changeImportInfoListWbweights.length) {
                setImportance({
                    ...this.getPublicInfo(),
                    storyIds: changeImportInfoListIds.join("|"),
                    wbweightstr: changeImportInfoListWbweights.join("|")
                }, (data) => {
                    if (data === true) {
                        message.info("重要性保存成功");
                        //刷新列表
                        this.reloadTableData();
                    } else {
                        message.error("重要性保存失败");
                    }
                })
            } else if (changeImportInfoListIds.length === 0) {
                message.error("没有修改重要性，无需保存");
            }
        }
    }
}

DragSortingTable.defaultProps = {
    showBtnArea: true, //默认显示
    type: "all",
    url: "/cm-sites-" + applicationName() + "/website/getStoryByColumn",
    start: 1,
    size: 10
};

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
        sysConfig: state.systemReducer.config,

    }
}


export default connect(mapStateToProps)(DragSortingTable);


const CollectionCreateForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
        render() {
            const { visible, onCancel, onCreate, form, initData, confirmLoading } = this.props;
            const { getFieldDecorator } = form;
            return (
                <Modal
                    visible={visible}
                    title="邮件信息"
                    okText="发送"
                    onCancel={onCancel}
                    onOk={onCreate}
                    confirmLoading={confirmLoading}
                >
                    <div className={'email_title'}>
                        <Form layout="vertical">
                            <Form.Item label="主题">
                                {getFieldDecorator('emailTitle', {
                                    initialValue: initData.title,
                                    rules: [{ required: true, message: '填写主题' }],
                                })(<Input />)}
                            </Form.Item>
                            <Form.Item label="内容">
                                {getFieldDecorator('emailContent', { initialValue: initData.title })(<TextArea
                                    placeholder="请输入邮件内容"
                                    autoSize={{ minRows: 2, maxRows: 6 }}
                                />)}
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
            );
        }
    },
);
